<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="alertas.content"
      :expanded.sync="expanded"
      class="mt-5"
      :loading="loading"
      :server-items-length="alertas.total"
      @update:options="updateOptions"
      :footer-props="footerOptions"
      no-data-text="Nenhum alerta encontrado"
      loading-text="Carregando alertas..."
      :options="optionsList"
    >
      <template v-slot:item.ativo="{ item }">
        <px-ativo small :ativo="item.ativo"/>
      </template>
      <template v-slot:item.createdIn="{ item  }">
        {{ item.createdIn | date(true) }}
      </template>
      <template v-slot:item.valor="{ item  }">
        {{ item.valor | currency }}
      </template>
      <template v-slot:item.precoAVista="{ item  }">
        {{ item.oferta.precoAVista | currency }}
      </template>
      <template v-slot:item.precoPromocaoAVista="{ item  }">
        {{ item.oferta.precoPromocaoAVista | currency }}
      </template>
      <template v-slot:item.options="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn icon
                   link
                   :to="`/marketplace/cadastro-oferta/${item.oferta.id}`"
                   target="_blank"
                   v-on="on">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </template>
          <span>Editar oferta</span>
        </v-tooltip>
        <px-open-oferta is-marketplace :oferta="item.oferta"/>
      </template>
    </v-data-table>
    <px-confirm-dialog ref="confirm"/>
  </div>
</template>

<script>
export default {
  props: {
    alertas: Object,
    default: [],
    loading: Boolean,
    onChangeOptions: {
      type: Function,
      required: true,
    },
    optionsList: Object,
  },
  data() {
    return {
      expanded: [],
      footerOptions: {
        itemsPerPageOptions: [5, 10, 15, 20],
        itemsPerPageText: 'Linhas por página',
      },
      headers: [
        {
          text: 'Oferta',
          value: 'oferta.titulo',
        },
        {
          text: 'Preço objetivo',
          value: 'valor',
        },
        {
          text: 'Preço à vista',
          value: 'precoAVista',
          sortable: false,
        },
        {
          text: 'Preço promocional',
          value: 'precoPromocaoAVista',
          sortable: false,
        },
        {
          text: 'Data de criação',
          value: 'createdIn',
        },
        {
          text: 'Ativo',
          value: 'ativo',
        },
        {
          text: null,
          sortable: false,
          value: 'options',
        },
      ],
    };
  },
  computed: {},
  methods: {
    updateOptions(options) {
      this.onChangeOptions(options);
    },
  },
};
</script>
